import { useFormNamespaceContext } from '../FormNamespaceProvider';
import { getFullFieldName } from '../utils/formContextUtils';

export const useNamespaceField = (field, useHash) => {
    const { getDataPathPrefix, getHashPrefix } = useFormNamespaceContext();
    const fullFieldName = getFullFieldName(field, useHash ? getHashPrefix : getDataPathPrefix);

    return fullFieldName;
};
